import navStateLoader from "./navTsgStateLoader";
import leftNavExt from "./leftNavExt";
import routesExt from "./routesExt";
import pdfReportExt from "./pdfReportExt";


export default [pdfReportExt, navStateLoader, leftNavExt, routesExt];